// Import all images
import gina from '../assets/Gina.png';
import gina1 from '../assets/Gina1.png';
import gina2 from '../assets/Gina2.png';
import gina3 from '../assets/Gina3.png';

import cartier from '../assets/Czupur.png';// Cartier's profile pic is Czupur.png
import cartier1 from '../assets/Czupur1.png';
import cartier2 from '../assets/Czupur2.png';
import cartier3 from '../assets/Czupur3.png';
import cartier4 from '../assets/Czupur4.png';
import cartier5 from '../assets/Czupur5.png';

import alicja from '../assets/Alicja.png';
import alicja1 from '../assets/Alicja1.png';
import alicja2 from '../assets/Alicja2.png';
import alicja3 from '../assets/Alicja3.png';

import yumi from '../assets/Yumi.png';
import yumi1 from '../assets/Yumi1.png';
import yumi2 from '../assets/Yumi2.png';
import yumi3 from '../assets/Yumi3.png';
import yumi4 from '../assets/Yumi4.png';
import yumi5 from '../assets/Yumi5.png';
import yumi6 from '../assets/Yumi6.png';
import yumi7 from '../assets/Yumi7.png';
import yumi8 from '../assets/Yumi8.png';
import yumi9 from '../assets/Yumi9.png';

import szarlotka from '../assets/Szarlotka.png';
import szarlotka1 from '../assets/Szarlotka1.png';
import szarlotka2 from '../assets/Szarlotka2.png';

import marta from '../assets/Marta.png';
import marta1 from '../assets/Marta1.png';
import marta2 from '../assets/Marta2.png';
import marta3 from '../assets/Marta3.png';

import jurek from '../assets/Jurek.png';
import jurek1 from '../assets/Jurek1.png';
import jurek2 from '../assets/Jurek2.png';
import jurek3 from '../assets/Jurek3.png';
import jurek4 from '../assets/Jurek4.png';

import sushi from '../assets/Sushi.png';
import sushi1 from '../assets/Sushi1.png';
import sushi2 from '../assets/Sushi2.png';
import sushi3 from '../assets/Sushi3.png';

// Pedigree images
import pedigreeGina from '../assets/ZrzutGina.png';
import pedigreeCartier from '../assets/ZrzutCartier.png';
import pedigreeAlicja from '../assets/ZrzutAlicja.png';
import pedigreeYumi from '../assets/ZrzutYumi.png';
import pedigreeSzarlotka from '../assets/ZrzutSzarlotka.png';
import pedigreeMarta from '../assets/ZrzutMarta.png';
import pedigreeJurek from '../assets/ZrzutJurek.png';

// Import new images for dogs
// Cartier new images
import cartierNew1 from '../assets/Cartier/Cartier/IMG_0072.JPG';
import cartierNew2 from '../assets/Cartier/Cartier/IMG_0097.JPG';
import cartierNew3 from '../assets/Cartier/Cartier/IMG_0121.JPG';
import cartierNew4 from '../assets/Cartier/Cartier/IMG_6439.jpg';

// Gina new images
import ginaNew1 from '../assets/Gina/Gina/IMG_4138.jpg';
import ginaNew2 from '../assets/Gina/Gina/IMG_8292.PNG';
import ginaNew3 from '../assets/Gina/Gina/Kopia pliku IMG_6980.jpg';
import ginaNew4 from '../assets/Gina/Gina/P1393830.JPG';
import ginaNew5 from '../assets/Gina/Gina/e0b2d95b-c97c-4719-a4c4-4cecc15d9d23.jpg';

// Jerzy (Yoshimitsu) new images
import jurekNew5 from '../assets/Jerzy/Jerzy/7Y3A5192.jpg';

// Szarlotka (Charlotte) new images
import szarlotkaNew3 from '../assets/Szarlotka/Szarlotka/879a0079-27f7-4a5d-bcf7-7e0bedf0ecee.jpg';
import szarlotkaNew4 from '../assets/Szarlotka/Szarlotka/IMG_5108.JPG';
import szarlotkaNew5 from '../assets/Szarlotka/Szarlotka/b48150b5-0b60-41c1-84f4-d49ca3c9af19.jpg';

// Martina (Marta) new images
/*import martaNew4 from '../assets/Martina/Martina/IMG_5113.JPG';
import martaNew5 from '../assets/Martina/Martina/IMG_5114.JPG';
import martaNew6 from '../assets/Martina/Martina/IMG_5115.JPG';*/


export const dogs = [
  // Females
  { id: 'gina', name: 'Gina', fullName: 'Harizma Virginiya', birthDate: '01.06.2020', category: 'females', profileImage: gina, images: [gina1, gina2, gina3, ginaNew1, ginaNew2, ginaNew3, ginaNew4, ginaNew5], pedigreeImage: pedigreeGina, origin: 'Import Rosja', description: {
    pl: `Młodzieżowy champion polski  
                   Champion Polski                         
              Grand Champion Polski                    
 Champion Bośni i Herzegoviny   
C.I.B Interchampion 
Zwycięzca Europy 2021 

Badania: 
PRA 0/0
GM2 0/0 
PATELLA 0/0
ECVO CLEAR
ECHO HEART 2021,2023 CLEAR`, 
    en: `Młodzieżowy champion polski  
                   Champion Polski                         
              Grand Champion Polski                    
 Champion Bośni i Herzegoviny   
C.I.B Interchampion 
Zwycięzca Europy 2021 

Badania: 
PRA 0/0
GM2 0/0 
PATELLA 0/0
ECVO CLEAR
ECHO HEART 2021,2023 CLEAR` } },

  { id: 'cartier', name: 'Cartier', fullName: 'Jaschin Cartier', birthDate: '14.08.2021', category: 'females', profileImage: cartier, images: [cartier1, cartier2, cartier3, cartier4, cartier5, cartierNew1, cartierNew2, cartierNew3, cartierNew4], pedigreeImage: pedigreeCartier, origin: 'Import Wielka Brytania', description: {
    pl: `Młodzieżowy Champion Polski 
Młodzieżowy Zwycięzca Pomorza 2022
Champion Polski 
Grand Champion Polski 
Zwycięzca klubu 2025 
Best of group |V
 
Badania:
Patella 0/0
PRA 0/0
GM2 0/0
Badanie serca poprzez echo czyste 2023 r
ECVO czyste`, 
    en: `Młodzieżowy Champion Polski 
Młodzieżowy Zwycięzca Pomorza 2022
Champion Polski 
Grand Champion Polski 
Zwycięzca klubu 2025 
Best of group |V
 
Badania:
Patella 0/0
PRA 0/0
GM2 0/0
Badanie serca poprzez echo czyste 2023 r
ECVO czyste` } },

  { id: 'alicja', name: 'Alicja', fullName: 'Alice In Wonderland Baltic Sand', birthDate: '11.01.2021', category: 'females', profileImage: alicja, images: [alicja1, alicja2, alicja3], pedigreeImage: pedigreeAlicja, description: { 
    pl: `Best in show minion puppy 
Champion Polski 

Badania 
Patella 0/0 
PRA 0/0
GM2 0/0
ECVO Czyste 
Badanie serca poprzez echo czyste 2023 r`, 
    en: `Best in show minion puppy 
Champion Polski 

Badania 
Patella 0/0 
PRA 0/0
GM2 0/0
ECVO Czyste 
Badanie serca poprzez echo czyste 2023 r` } },

  { id: 'yumi', name: 'Yumi', fullName: 'Yumi Etsuko', birthDate: '03.08.2022', category: 'females', profileImage: yumi, images: [yumi1, yumi2, yumi3, yumi4, yumi5, yumi6, yumi7, yumi8, yumi9], pedigreeImage: pedigreeYumi, description: { 
    pl: `Best In Show Minior Puppy IV 
Młodzieżowy zwycięzca Polski 2023
Młodzieżowy champion Polski 

Pra 0/0 
GM2 0/0
Badanie serca poprzez echo czyste 2023`, 
    en: `Best In Show Minior Puppy IV 
Młodzieżowy zwycięzca Polski 2023
Młodzieżowy champion Polski 

Pra 0/0 
GM2 0/0
Badanie serca poprzez echo czyste 2023` } },

  { id: 'szarlotka', name: 'Szarlotka', fullName: 'Charlotte Etsuko', birthDate: '04.04.2024', category: 'females', profileImage: szarlotka, images: [szarlotka1, szarlotka2, szarlotkaNew3, szarlotkaNew4, szarlotkaNew5], pedigreeImage: pedigreeSzarlotka, description: {
    pl: `Puppy champion of Poland 
Junior champion of Poland 

Badania 
Patella 0/0
 PRA 0/0 
GM 0/0 
CDDY 0/0 
IVDD 0/0 

2 kopie sobolowego 
1 kopia dominującego czarnego 
1 kopia recesywnego czerwoneg`, 
    en: `Puppy champion of Poland 
Junior champion of Poland 

Badania 
Patella 0/0
 PRA 0/0 
GM 0/0 
CDDY 0/0 
IVDD 0/0 

2 kopie sobolowego 
1 kopia dominującego czarnego 
1 kopia recesywnego czerwoneg` } },

  { id: 'marta', name: 'Marta', fullName: 'I Have A Dream Etsuko', birthDate: '30.07.2024', category: 'females', profileImage: marta, images: [marta1, marta2, marta3], pedigreeImage: pedigreeMarta, description: {
    pl: `Puppy champion of Poland 
  
Badania 
 PRA 0/0 
GM 0/0 
CDDY 0/0 
IVDD 0/0 

1 kopia dominującego czarnego
1 kopia recesywnego czerwonego 
1 kopia tricolor  
1 kopia sobolowego`, 
    en: `Puppy champion of Poland 
  
Badania 
 PRA 0/0 
GM 0/0 
CDDY 0/0 
IVDD 0/0 

1 kopia dominującego czarnego
1 kopia recesywnego czerwonego 
1 kopia tricolor  
1 kopia sobolowego`} },


  // Males
  { id: 'jurek', name: 'Jurek', fullName: 'Yoshimitsu Etsuko', birthDate: '03.08.2022', category: 'males', profileImage: jurek, images: [jurek1, jurek2, jurek3, jurek4, jurekNew5], pedigreeImage: pedigreeJurek, description: {
    pl: `Młodzieżowy champion Polski 
Młodzieżowy champion Słowacji 
Młodzieżowy champion Litwy 
Młodzieżowy Interchampion 
Champion Polski 

Badania
 Patella 0/0 
Pra 0/0 
GM2 0/0
Badanie serca poprzez echo czyste 2023`, 
    en: `Młodzieżowy champion Polski 
Młodzieżowy champion Słowacji 
Młodzieżowy champion Litwy 
Młodzieżowy Interchampion 
Champion Polski 

Badania
 Patella 0/0 
Pra 0/0 
GM2 0/0
Badanie serca poprzez echo czyste 2023` } },

  
  // In memory
  { id: 'sushi', name: 'Sushi', fullName: 'Sushi ** RIP ** 01.03.2025 **', birthDate: null, category: 'memory', profileImage: sushi, images: [sushi1, sushi2, sushi3], description: { pl: 'Opis Sushi...', en: 'Description of Sushi...' } },
]; 